/* eslint-disable no-underscore-dangle */
import { parseISO, isEqual, isAfter } from 'date-fns';
import _isNumber from 'lodash/isNumber';
import { PREMIUM_CAP_ENTITY } from 'constants/logic';
import { rulesValidatorMessages as messages } from '../PremiumCaps.messages';

export function syncValidator(values) {
  const { ruleEntity, ruleEntityId, spotCap } = values;
  const errors = {};

  if (!_isNumber(spotCap)) {
    errors.spotCap = messages.required;
  } else if (spotCap < 0 || spotCap > 9000) {
    errors.spotCap = messages.spotCapRange;
  }

  if (
    (ruleEntity === PREMIUM_CAP_ENTITY.CLASS && !ruleEntityId) ||
    (ruleEntity === PREMIUM_CAP_ENTITY.SCHEDULE && !ruleEntityId)
  ) {
    errors.ruleEntityId = messages.required;
  }

  return errors;
}

export function submitValidator(values) {
  const {
    ruleEntity,
    ruleEntityId,
    spotCap,
    recurrence: { dateStart, dateEnd, timeOfDayStart, timeOfDayEnd },
    displayData: { isOngoing },
  } = values;
  const errors = {};

  if (!_isNumber(spotCap)) {
    errors.spotCap = messages.required;
  } else if (spotCap < 0 || spotCap > 9000) {
    errors.spotCap = messages.spotCapRange;
  }

  if (ruleEntity === PREMIUM_CAP_ENTITY.SCHEDULE && !ruleEntityId) {
    errors._error = messages.scheduleIdRequired;
  }

  if (ruleEntity === PREMIUM_CAP_ENTITY.CLASS && !ruleEntityId) {
    errors._error = messages.classIdRequired;
  }

  if (ruleEntity === PREMIUM_CAP_ENTITY.VENUE && !isOngoing) {
    const start = parseISO(`${dateStart} ${timeOfDayStart}`);
    const end = parseISO(`${dateEnd} ${timeOfDayEnd}`);

    if (isEqual(start, end) || isAfter(start, end)) {
      errors._error = ruleEntity === PREMIUM_CAP_ENTITY.VENUE ? messages.dateOrder : messages.timeOrder;
    }
  }

  return errors;
}
